import { c as cjs } from './cjs-9df6abb2.js';

/* Тип токенов сделан через any, т.к. туда передаётся константа, полученная из JSON. Использование здесь типа Tokens во-первых потребует передачи tokens as Tokens, а во-вторых помешает обращаться к рекордам вроде цветов при прописывании темы, т.к. токены перестанут быть константой. Типизация же им ни к чему, т.к. токены не пишутся руками. */
/**
 * Helper for creating custom theme. Makes deep merge of tokens and theme settings.
 */
var createTheme = function createTheme() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$tokens = _ref.tokens,
    tokens = _ref$tokens === void 0 ? {} : _ref$tokens,
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? {} : _ref$settings;
  return cjs(tokens, settings);
};

export { createTheme };
